import { render } from "./testimonialThree.vue?vue&type=template&id=253158be"
import script from "./testimonialThree.vue?vue&type=script&lang=js"
export * from "./testimonialThree.vue?vue&type=script&lang=js"

import "./testimonialThree.vue?vue&type=style&index=0&id=253158be&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__